<!-- Accordion Filter type -->
<suvo-bi-filters-accordion [autoApplyFilters]="autoApplyFilters || (!allowed)" [enableAccordionClose]="false"
    [filtersChannel]="filtersChannel" [exportDisabled]="exportDisabled"></suvo-bi-filters-accordion>